import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "list", "gridButton", "listButton", "form", "viewInput"]
  static values = {
    view: String
  }

  connect() {
    const view = this.viewValue || 'list'
    this[`show${view.charAt(0).toUpperCase() + view.slice(1)}`]()
  }

  showGrid() {
    this.gridTarget.classList.remove("hidden")
    this.listTarget.classList.add("hidden")
    
    this.gridButtonTarget.classList.add("bg-zinc-100", "dark:bg-zinc-700")
    this.gridButtonTarget.classList.remove("bg-white", "dark:bg-zinc-800")
    this.listButtonTarget.classList.remove("bg-zinc-100", "dark:bg-zinc-700")
    this.listButtonTarget.classList.add("bg-white", "dark:bg-zinc-800")

    if (this.hasViewInputTarget) {
      this.viewInputTarget.value = 'grid'
    }
    this.viewValue = 'grid'
    this.updateURL('grid')
  }

  showList() {
    this.gridTarget.classList.add("hidden")
    this.listTarget.classList.remove("hidden")
    
    this.listButtonTarget.classList.add("bg-zinc-100", "dark:bg-zinc-700")
    this.listButtonTarget.classList.remove("bg-white", "dark:bg-zinc-800")
    this.gridButtonTarget.classList.remove("bg-zinc-100", "dark:bg-zinc-700")
    this.gridButtonTarget.classList.add("bg-white", "dark:bg-zinc-800")

    if (this.hasViewInputTarget) {
      this.viewInputTarget.value = 'list'
    }
    this.viewValue = 'list'
    this.updateURL('list')
  }

  updateView(event) {
    if (this.viewValue) {
      const view = this.viewValue
      this[`show${view.charAt(0).toUpperCase() + view.slice(1)}`]()
    }
  }

  updateURL(view) {
    // Update URL to persist view preference without page reload, keeping existing params
    const url = new URL(window.location)
    url.searchParams.set('view', view)
    window.history.replaceState({}, '', url)
  }
}